import * as Yup from 'yup'

import { getLineItemPixels } from './helpers'

import { PIXELS } from '../../../LineItemDv360Create/LineItemDv360CreateForm/LineItemDV360CreateMainForm/fields'

export const getInitialValues = (lineItem, pixels) => {
  return {
    [PIXELS]: getLineItemPixels(lineItem, pixels)
  }
}

export const validationSchema = Yup.object({
  [PIXELS]: Yup.array().min(1, 'Please select at least one pixel')
})
